export default __webpack_public_path__ + "dist/media/FileDocument.954a2918.svg";